import { render, staticRenderFns } from "./SemenCollection.vue?vue&type=template&id=f02a51a4&scoped=true&"
import script from "./SemenCollection.vue?vue&type=script&lang=js&"
export * from "./SemenCollection.vue?vue&type=script&lang=js&"
import style0 from "./SemenCollection.vue?vue&type=style&index=0&id=f02a51a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02a51a4",
  null
  
)

export default component.exports